<div class="wrapper">
  <div id="gameButtons">
    <div class="buttonAndLabel">
      <p>Restart</p>
      <div (click)="triggerRestart()" id="restart" class="button"><img src="assets/img/restart.png"></div>
    </div>
    <div class="buttonAndLabel">
      <p>Pause</p>
      <div (click)="triggerPause()" id="pause" class="button"><img src="assets/img/pause.png"></div>
    </div>
    <div class="buttonAndLabel">
      <p>Infos</p>
      <div id="infos" class="button"><img src="assets/img/point-dinterrogation.png">
        <div class="hiddenInfo">
          <h3>Commands</h3>
          <table>
            <tr>
              <th>input</th><th>icon</th><th>effect</th>
            </tr>
            <tr>
              <td><b>up arrow - spacebar </b></td><td><img class="infoIcon" src="assets/img/refresh.png"></td> <td>rotates piece</td>
            </tr>
            <tr>
              <td><b>down arrow</b></td><td><img class="infoIcon" src="assets/img/down-arrow.png"></td><td>makes currently falling piece fall faster</td>
            </tr>
            <tr>
              <td><b>right arrow</b></td> <td><img class="infoIcon" src="assets/img/right-arrow.png"></td> <td>makes currently falling piece move right</td>
            </tr>
            <tr>
              <td><b>left arrow</b></td><td><img class="infoIcon" src="assets/img/left-arrow.png"></td> <td>makes currently falling piece move left</td>
            </tr>
            <tr>
              <td><b>0 - Enter</b></td> <td></td> <td>makes currently falling piece fall all the way to the bottom</td>
            </tr>
          </table>

          <h3>Score</h3>

          <table>
            <tr>
              <th>Level</th><th>Points for 1 line</th><th>Points for 2 line</th><th>Points for 3 line</th><th>Points for 4 line</th>
            </tr>
            <tr>
              <td>0</td><td>40</td><td>100</td><td>300</td><td>1200</td>
            </tr>
            <tr>
              <td>1</td><td>80</td><td>200</td><td>600</td><td>2400</td>
            </tr>
            <tr>
              <td>2</td><td>120</td><td>300</td><td>900</td><td>3600</td>
            </tr>
            <tr>
              <td>...</td><td>...</td><td>...</td><td>...</td><td>...</td>
            </tr>
            <tr>
              <td>9</td><td>400</td><td>1000</td><td>3000</td><td>12000</td>
            </tr>
            <tr>
              <td>n</td><td>40 x (n+1)</td><td>100 x (n+1)</td><td>300 x (n+1)</td><td>1200 x (n+1)</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="break"></div>
</div>
